import type { SlotProps } from '@radix-ui/react-slot';
/* eslint-disable-next-line no-restricted-imports */
import { Slot as RadixSlot } from '@radix-ui/react-slot';
import React, { forwardRef, useEffect, useRef } from 'react';

const FLAG_ATTRIBUTE = 'data-slab-slot';

const Slot =
  process.env.NODE_ENV === 'production'
    ? RadixSlot
    : forwardRef<HTMLElement, SlotProps>((providedProps, providedRef) => {
        const ref = useRef<HTMLElement>(null);

        useEffect(() => {
          if (!ref.current) {
            throw new Error(
              'Child of <Slot> must forward ref to the element it renders',
            );
          }
          if (!ref.current.hasAttribute(FLAG_ATTRIBUTE)) {
            throw new Error(
              'Child of <Slot> must pass all HTML attributes to the element it renders',
            );
          }
        }, []);

        return (
          <RadixSlot ref={ref}>
            <RadixSlot
              {...{ ...providedProps, [FLAG_ATTRIBUTE]: true }}
              ref={providedRef}
            />
          </RadixSlot>
        );
      });

export default Slot;
